var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-tool",
      class:
        ((_obj = {
          active: _vm.isMenuActive(),
          "mobile-sidebar": _vm.isMobile,
        }),
        (_obj[_vm.className] = _vm.className),
        _obj),
    },
    [
      _c(
        "div",
        {
          staticClass: "sidebar-content",
          on: {
            mouseenter: _vm.mouseEnterStart,
            mouseleave: _vm.mouseLeaveStart,
          },
        },
        [
          _vm.titleEnabled && _vm.isMenuActive()
            ? _c("div", { staticClass: "sidebar-title" }, [_vm._t("title")], 2)
            : _vm._e(),
          _vm._v(" "),
          _vm.cloneItems.length > 0
            ? _c("div", { staticClass: "sidebar-menu" }, [
                _c(
                  "div",
                  { staticClass: "sidebar-menu-content" },
                  [
                    _vm.enableNonGroupedDraggable
                      ? _c(
                          "draggable",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { options: _vm.getDraggableOptions() },
                            on: { end: _vm.onNonGroupedDragEnd },
                            model: {
                              value: _vm.cloneItems,
                              callback: function ($$v) {
                                _vm.cloneItems = $$v
                              },
                              expression: "cloneItems",
                            },
                          },
                          [
                            _vm._l(_vm.cloneItems, function (item) {
                              return [
                                _c(
                                  "SidebarItemTooltip",
                                  {
                                    key: item.key,
                                    attrs: {
                                      "title-text": item.label,
                                      "rich-description":
                                        item.filterDescription || "",
                                      "filter-icon": item.filterData
                                        ? item.icon
                                        : null,
                                      "menu-active": _vm.isMenuActive(),
                                    },
                                  },
                                  [
                                    item.route
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass: "menu-item",
                                            attrs: { to: item.route },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleRouteClick(
                                                  item,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("SidebarChildItem", {
                                              attrs: {
                                                item: item,
                                                isSelected: _vm.isSelected,
                                                isMenuActive: _vm.isMenuActive,
                                                showSearchButton:
                                                  item.showSearchButton,
                                                searchCallback:
                                                  item.searchCallback,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c("SidebarChildItem", {
                                          attrs: {
                                            item: item,
                                            isSelected: _vm.isSelected,
                                            isMenuActive: _vm.isMenuActive,
                                            showSearchButton:
                                              item.showSearchButton,
                                            searchCallback: item.searchCallback,
                                          },
                                          on: {
                                            selected: _vm.fnCallback,
                                            clicked: _vm.fnCallback,
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : [
                          _vm._l(_vm.cloneItems, function (item) {
                            return [
                              _c(
                                "SidebarItemTooltip",
                                {
                                  key: item.key,
                                  attrs: {
                                    "title-text": item.label,
                                    "rich-description":
                                      item.filterDescription || "",
                                    "filter-icon": item.filterData
                                      ? item.icon
                                      : null,
                                    "menu-active": _vm.isMenuActive(),
                                  },
                                },
                                [
                                  item.route
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "menu-item",
                                          attrs: { to: item.route },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleRouteClick(
                                                item,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("SidebarChildItem", {
                                            attrs: {
                                              item: item,
                                              isSelected: _vm.isSelected,
                                              isMenuActive: _vm.isMenuActive,
                                              showSearchButton:
                                                item.showSearchButton,
                                              searchCallback:
                                                item.searchCallback,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c("SidebarChildItem", {
                                        attrs: {
                                          item: item,
                                          isSelected: _vm.isSelected,
                                          isMenuActive: _vm.isMenuActive,
                                          showSearchButton:
                                            item.showSearchButton,
                                          searchCallback: item.searchCallback,
                                        },
                                        on: {
                                          selected: _vm.fnCallback,
                                          clicked: _vm.fnCallback,
                                        },
                                      }),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.groupedItems, function (groupItem) {
            return _c(
              "div",
              { key: groupItem.name, staticClass: "sidebar-grouped" },
              [
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      title: groupItem.name,
                      placement: "right",
                      overlayClassName: _vm.isMenuActive()
                        ? ""
                        : "hiddenToolTip",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "sidebar-grouped-head",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSubMenu(groupItem)
                          },
                          touchend: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleSubMenu(groupItem)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sidebar-grouped-head-title" },
                          [_vm._v(_vm._s(groupItem.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sidebar-grouped-head-collapse" },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  groupItem.showMore
                                    ? "expand_less"
                                    : "expand_more"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sidebar-menu",
                    class: { closed: !groupItem.showMore },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "sidebar-menu-content" },
                      [
                        groupItem.items.length === 0
                          ? [_vm._t(groupItem.name + "-empty")]
                          : [
                              groupItem.isDraggable
                                ? _c(
                                    "draggable",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        options: _vm.getDraggableOptions(),
                                      },
                                      on: {
                                        end: function ($event) {
                                          return _vm.onDragEnd(groupItem)
                                        },
                                      },
                                      model: {
                                        value: groupItem.items,
                                        callback: function ($$v) {
                                          _vm.$set(groupItem, "items", $$v)
                                        },
                                        expression: "groupItem.items",
                                      },
                                    },
                                    [
                                      _vm._l(groupItem.items, function (item) {
                                        return [
                                          _c(
                                            "SidebarItemTooltip",
                                            {
                                              key: item.key,
                                              attrs: {
                                                "title-text": item.label,
                                                "rich-description":
                                                  item.filterDescription || "",
                                                "filter-icon": item.filterData
                                                  ? item.icon
                                                  : null,
                                                "menu-active":
                                                  _vm.isMenuActive(),
                                              },
                                            },
                                            [
                                              item.route
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: { to: item.route },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleRouteClick(
                                                            item,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("SidebarChildItem", {
                                                        attrs: {
                                                          item: item,
                                                          isSelected:
                                                            _vm.isSelected,
                                                          isMenuActive:
                                                            _vm.isMenuActive,
                                                          showSearchButton:
                                                            item.showSearchButton,
                                                          searchCallback:
                                                            item.searchCallback,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("SidebarChildItem", {
                                                    attrs: {
                                                      item: item,
                                                      isSelected:
                                                        _vm.isSelected,
                                                      isMenuActive:
                                                        _vm.isMenuActive,
                                                      showSearchButton:
                                                        item.showSearchButton,
                                                      searchCallback:
                                                        item.searchCallback,
                                                    },
                                                    on: {
                                                      selected: _vm.fnCallback,
                                                    },
                                                  }),
                                            ],
                                            1
                                          ),
                                        ]
                                      }),
                                    ],
                                    2
                                  )
                                : [
                                    _vm._l(groupItem.items, function (item) {
                                      return [
                                        _c(
                                          "SidebarItemTooltip",
                                          {
                                            key: item.key,
                                            attrs: {
                                              "title-text": item.label,
                                              "rich-description":
                                                item.filterDescription || "",
                                              "filter-icon": item.filterData
                                                ? item.icon
                                                : null,
                                              "menu-active": _vm.isMenuActive(),
                                            },
                                          },
                                          [
                                            item.route
                                              ? _c(
                                                  "router-link",
                                                  {
                                                    attrs: { to: item.route },
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.handleRouteClick(
                                                          item,
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("SidebarChildItem", {
                                                      attrs: {
                                                        item: item,
                                                        isSelected:
                                                          _vm.isSelected,
                                                        isMenuActive:
                                                          _vm.isMenuActive,
                                                        showSearchButton:
                                                          item.showSearchButton,
                                                        searchCallback:
                                                          item.searchCallback,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _c("SidebarChildItem", {
                                                  attrs: {
                                                    item: item,
                                                    isSelected: _vm.isSelected,
                                                    isMenuActive:
                                                      _vm.isMenuActive,
                                                    showSearchButton:
                                                      item.showSearchButton,
                                                    searchCallback:
                                                      item.searchCallback,
                                                  },
                                                  on: {
                                                    selected: _vm.fnCallback,
                                                  },
                                                }),
                                          ],
                                          1
                                        ),
                                      ]
                                    }),
                                  ],
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-tool-collapse",
          on: {
            click: _vm.toggle,
            touchend: function ($event) {
              $event.preventDefault()
              return _vm.toggle.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "information-text" }, [
            _vm._v(_vm._s(_vm.$t("message.showHide"))),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "material-icons" }, [
              _vm._v(
                _vm._s(_vm.isMenuActive() ? "chevron_left" : "chevron_right")
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }